{
  "createFenceDevice": {}
}
